import SpecialOfferTable from "./page/SpecialOfferTable";

const SpecialOffer:React.FC =()=>{
    return(
        <>
        <SpecialOfferTable/>
        </>
    )
};
export default SpecialOffer;